// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ExpandableClamp__label":"bbk_a bhi_hg bhi_ry bhi_xj"};